import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonActionPanelComponent } from '../../../common/common-action-panel-component.directive';
import { Observable } from 'rxjs';
import {
  AbstractControl,
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { RuleInterface } from '@vendasta/automata';
import {
  OUTBOUND_CALL,
  INBOUND_CALL,
  EMAIL_SENT,
  EMAIL_RECEIVED,
  MEETING,
  OTHER,
  FOLLOW_UP_NEEDED,
  IN_PROGRESS,
} from '../constant';
import { AutomationVariableMenuComponent } from '../../../../../common/components/automation-variable-menu/automation-variable-menu.component';
import { insertVariable } from '../../../../../common/components/automation-variable-menu/automation-variable-menu.service';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@Component({
  selector: 'automata-log-sales-activity-panel',
  templateUrl: './log-sales-activity-panel.component.html',
  styleUrls: ['./log-sales-activity-panel.component.scss'],
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    AutomationVariableMenuComponent,
    MatSlideToggleModule,
  ],
})
export class LogSalesActivityPanelComponent extends CommonActionPanelComponent implements OnInit {
  actionControl: UntypedFormControl = new FormControl('', [Validators.required]);
  customActionControl: UntypedFormControl = new FormControl('', [Validators.required]);
  notesControl: UntypedFormControl = new FormControl('');
  statusControl: UntypedFormControl = new UntypedFormControl();

  @ViewChild('customAction', { static: false }) customAction;
  showCustomActionInput$: Observable<boolean>;
  salesActivitiesOptions: any = [
    { text: 'AUTOMATIONS.EDITOR.TASKS.LOG_SALES_ACTIVITY.SELECT_ACTIVITY_OPTION.OUTBOUND_CALL', value: OUTBOUND_CALL },
    { text: 'AUTOMATIONS.EDITOR.TASKS.LOG_SALES_ACTIVITY.SELECT_ACTIVITY_OPTION.INBOUND_CALL', value: INBOUND_CALL },
    { text: 'AUTOMATIONS.EDITOR.TASKS.LOG_SALES_ACTIVITY.SELECT_ACTIVITY_OPTION.EMAIL_SENT', value: EMAIL_SENT },
    {
      text: 'AUTOMATIONS.EDITOR.TASKS.LOG_SALES_ACTIVITY.SELECT_ACTIVITY_OPTION.EMAIL_RECEIVED',
      value: EMAIL_RECEIVED,
    },
    { text: 'AUTOMATIONS.EDITOR.TASKS.LOG_SALES_ACTIVITY.SELECT_ACTIVITY_OPTION.MEETING', value: MEETING },
    { text: 'AUTOMATIONS.EDITOR.TASKS.LOG_SALES_ACTIVITY.SELECT_ACTIVITY_OPTION.OTHER', value: OTHER },
  ];

  constructor() {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();

    const jsonData = this.step ? JSON.parse(this.step.data) : {};
    this.actionControl.setValue(jsonData.action);
    this.customActionControl.setValue(jsonData.custom_action_name);
    this.notesControl.setValue(jsonData.notes);
    this.statusControl.setValue(jsonData.status === FOLLOW_UP_NEEDED);

    this.showCustomActionInput$ = this.actionControl.valueChanges.pipe(
      map((action) => action === OTHER),
      startWith(this.actionControl.value === OTHER),
    );

    this.savingEnabled = true;
  }

  getRules(): RuleInterface[] {
    return [];
  }

  getData(): any {
    const jsonData = this.step ? JSON.parse(this.step.data) : {};
    if (!this.actionControl) {
      return jsonData;
    }

    jsonData.action = this.actionControl.value;
    jsonData.custom_action_name = this.customAction ? this.customActionControl.value : '';
    jsonData.notes = this.notesControl.value;
    jsonData.status = this.statusControl.value ? FOLLOW_UP_NEEDED : IN_PROGRESS;

    return jsonData;
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return this.customAction ? [this.actionControl, this.customActionControl] : [this.actionControl];
  }

  isFormValid(): boolean {
    const customActionValid = this.customAction ? this.customActionControl.valid : true;

    return this.actionControl.valid && customActionValid;
  }

  insertVariable(elementID: string, control: AbstractControl, variable: string): void {
    insertVariable(elementID, control, variable);
  }
}
